export enum CompetitorStatus {
  inActive = 0,
  Active = 1,
  Pending = 2
}
